import Button from '@components/Button';
import Image from '@components/Image';
import Row from '@components/Row';
import colors from '@constants/colors';
import useLoading from '@hooks/ui/useLoading';
import useProject from '@hooks/useProject';
import { Fragment } from 'react';

import AppleIcon from './ic_apple.svg';

const appleRedirectUri = import.meta.env.VITE_APPLE_REDIRECT_URI;

function AppleSignInButton() {
  const project = useProject();
  const { startLoading, stopLoading } = useLoading();
  const appleClientId = import.meta.env.MODE === 'production'
    ? project?.appleClientId : import.meta.env.VITE_APPLE_CLIENT_ID;
  const handleAppleSignIn = () => {
    startLoading();
    const timeout = setTimeout(() => {
      stopLoading();
      clearTimeout(timeout);
    }, 1500);
    const url = `https://appleid.apple.com/auth/authorize
?response_type=code
&client_id=${appleClientId}
&redirect_uri=${appleRedirectUri}
&response_mode=query`;
    window.open(url, '_self');
    return () => clearTimeout(timeout);
  };
  const isIos = !(navigator.userAgent.match(/iPhone|iPad|iPod/i) === null);
  if (isIos && appleClientId) {
    return (
        <Button onClick={handleAppleSignIn}
                backgroundColor='#000'
                color={colors.white}
                fullWidth >
            <Row spacing={7}>
                <Image src={AppleIcon}
                       width={20}
                       height={20}
                       alt='Apple 로그인'/>
                Apple로 로그인
            </Row>
        </Button>
    );
  }
  return (<Fragment/>);
}

export default AppleSignInButton;
